import { Injectable } from '@angular/core';
import { Store } from '../core/store-utils/store';

interface CoreUIState {
  headerShown: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class CoreUIStore extends Store<CoreUIState> {
  constructor() {
    super({
      headerShown: true,
    });
  }

  showHeader() {
    this.update({
      headerShown: true,
    });
  }

  hideHeader() {
    this.update({
      headerShown: false,
    });
  }
}
